import React, { Component } from 'react';
import { Modal, message } from 'antd';
import FormList from '../basicElement/FormList';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';

class UpdateJinshiCooperation extends Component {
    state = {
        data: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        const { userCooperation } = record;
        this.setState({
            visible: true,
            data: {
                ...record,
                userCooperation: userCooperation || '0',
            },
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (value, key, type) => {
        const { data } = this.state;
        data[key] = value;
        this.setState({ data });
    }

    getColumns = () => {
        const { data } = this.state;
        const { type } = this.props;

        // 字段属性配置
        const columns = [{
            name: '医院名称',
            key: 'hospitalName',
            type: 'text',
        }];
        if (type === 'DEPARTMENT' || type === 'DOCTOR') {
            columns.push({
                name: '科室',
                key: 'departmentLocalName',
                type: 'text',
            });
        }
        if (type === 'DOCTOR') {
            columns.push({
                name: '医生',
                key: 'userCompellation',
                type: 'text',
            });
        }
        columns.push({
            name: '与津石是否有合作',
            key: 'userCooperation',
            type: 'radio',
            typeProperty: {
                list: [{ label: '是', value: '1'}, { label: '否', value: '0'}],
            },
            rules: {
                required: true,
            }
        });

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, children, rules = {} } = column;
                if (children) {
                    traverseColumns(children);
                } else {
                    const typeProperty = column.typeProperty || (column.typeProperty = {});
                    typeProperty.canEdit = true;
                    typeProperty.value = data[key];
                }
            });
        }
        traverseColumns(columns);

        return columns;
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { data } = this.state;
        const { type } = this.props;
        const { hospitalId, hospitalDepartmentId, userId, userCooperation } = data;
        const infoId = (type === 'HOSPITAL' && hospitalId) || (type === 'DEPARTMENT' && hospitalDepartmentId) || (type === 'DOCTOR' && userId);

        this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.hospital.editHospitalInfoCooperation,
                data: {
                    type,
                    infoId,
                    userCooperation,
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.setState({
                        visible: false,
                        loading: false,
                    }, () => {
                        this.props.loadData();
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                }
            }
            $.sendRequest(options);
    }

    render() {
        const { loading, visible } = this.state;
        return (
            <Modal
                title="修改津石合作情况"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="420px"
                confirmLoading={loading}
            >
                <div style={{ margin: '10px 0' }}>
                    <FormList
                        className="form-list registerStartUp-list"
                        columns={this.getColumns()}
                        onChange={this.handleChange}
                        ref={el => this.formRef = el}
                    />
                </div>
            </Modal>
        );
    }
}

export default UpdateJinshiCooperation;


// WEBPACK FOOTER //
// ./src/components/hospital/UpdateJinshiCooperation.js